<!--<template>-->
<!--    &lt;!&ndash; Modal Overlay &ndash;&gt;-->
<!--    <Transition name="modal">-->
<!--        <div-->
<!--            v-if="isOpen"-->
<!--            class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto"-->
<!--            @click="closeModal"-->
<!--        >-->
<!--            &lt;!&ndash; Modal Content &ndash;&gt;-->
<!--            <div-->
<!--                class="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 p-8 relative"-->
<!--                @click.stop-->
<!--            >-->
<!--                &lt;!&ndash; Header &ndash;&gt;-->
<!--                <div class="flex justify-between items-center mb-8">-->
<!--                    <h2 class="w-full text-center text-xl font-semibold text-gray-800 tracking-wide">NEW BENEFICIARY</h2>-->
<!--                    <button-->
<!--                        @click="closeModal"-->
<!--                        class="text-gray-400 hover:text-gray-600 text-2xl leading-none"-->
<!--                    >-->
<!--                        ×-->
<!--                    </button>-->
<!--                </div>-->

<!--                &lt;!&ndash; Form &ndash;&gt;-->
<!--                <form @submit.prevent="handleSubmit" class="space-y-6">-->
<!--                    &lt;!&ndash; Name Field &ndash;&gt;-->
<!--                    <div class="space-y-4">-->
<!--                        <div>-->
<!--                            <FloatingLabelInput-->
<!--                                v-model="name"-->
<!--                                input-id="iban-field"-->
<!--                                label="Name *"-->
<!--                            />-->
<!--                        </div>-->

<!--                        <div>-->
<!--                            <FloatingLabelInput-->
<!--                                v-model="description"-->
<!--                                input-id="iban-field"-->
<!--                                label="Description *"-->
<!--                            />-->
<!--                        </div>-->

<!--                        <div>-->
<!--                            <FloatingLabelInput-->
<!--                                v-model="iban"-->
<!--                                input-id="iban-field"-->
<!--                                label="IBAN *"-->
<!--                            />-->
<!--                        </div>-->

<!--                        <div>-->
<!--                            <FloatingLabelInput-->
<!--                                v-model="swiftCode"-->
<!--                                input-id="iban-field"-->
<!--                                label="BIC / SWIFT Code *"-->
<!--                            />-->
<!--                        </div>-->

<!--                        <div class="mt-4">-->
<!--                              <textarea-->
<!--                                  v-model="additionalInfo"-->
<!--                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none"-->
<!--                                  placeholder="Additional Information"-->
<!--                                  rows="4"-->
<!--                              ></textarea>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Confirm Button &ndash;&gt;-->
<!--                    <div class="flex justify-end pt-4">-->
<!--                        <button-->
<!--                            type="submit"-->
<!--                            class="bg-gray-800 hover:bg-gray-600 text-white font-semibold px-8 py-3 rounded-md transition-colors duration-200 tracking-wide"-->
<!--                        >-->
<!--                            CONFIRM-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </form>-->
<!--            </div>-->
<!--        </div>-->
<!--    </Transition>-->
<!--</template>-->

<!--<script setup>-->
<!--import FloatingLabelInput from '@/components/ui/FloatingLabelInput.vue';-->
<!--import { ref, defineProps, defineEmits } from 'vue'-->

<!--const name = ref('')-->
<!--const description = ref('')-->
<!--const iban = ref('')-->
<!--const swiftCode = ref('')-->
<!--const additionalInfo = ref('')-->

<!--defineProps({-->
<!--    isOpen: {-->
<!--        type: Boolean,-->
<!--        default: false-->
<!--    }-->
<!--})-->

<!--const emit = defineEmits(['close', 'submit'])-->

<!--const formData = ref({-->
<!--    name: '',-->
<!--    description: '',-->
<!--    iban: '',-->
<!--    bicSwift: '',-->
<!--    additionalInfo: ''-->
<!--})-->

<!--const closeModal = () => {-->
<!--    emit('close')-->
<!--}-->

<!--const handleSubmit = () => {-->
<!--    emit('submit', formData.value)-->
<!--    // Reset form after submission-->
<!--    formData.value = {-->
<!--        name: '',-->
<!--        description: '',-->
<!--        iban: '',-->
<!--        bicSwift: '',-->
<!--        additionalInfo: ''-->
<!--    }-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->
<!--.modal-enter-active, .modal-leave-active {-->
<!--    transition: opacity 0.3s ease;-->
<!--}-->

<!--.modal-enter-from, .modal-leave-to {-->
<!--    opacity: 0;-->
<!--}-->

<!--.modal-enter-active .bg-white, .modal-leave-active .bg-white {-->
<!--    transition: transform 0.3s ease;-->
<!--}-->

<!--.modal-enter-from .bg-white, .modal-leave-to .bg-white {-->
<!--    transform: scale(0.9);-->
<!--}-->
<!--</style>-->


<template>
  <!-- Modal Overlay -->
  <Transition name="modal">
    <div
        v-if="isOpen"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto"
        @click="closeModal"
    >
      <!-- Modal Content -->
      <div
          class="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 p-8 relative"
          @click.stop
      >
        <!-- Header -->
        <div class="flex justify-between items-center mb-8">
          <h2 class="w-full text-center text-xl font-semibold text-gray-800 tracking-wide">
            NEW BENEFICIARY
          </h2>
          <button
              @click="closeModal"
              class="text-gray-400 hover:text-gray-600 text-2xl leading-none"
          >
            ×
          </button>
        </div>

        <!-- Form -->
        <form @submit.prevent="handleSubmit" class="space-y-6">
          <div class="space-y-4">
            <FloatingLabelInput
                v-model="formData.name"
                input-id="name-field"
                label="Name *"
            />

            <FloatingLabelInput
                v-model="formData.description"
                input-id="description-field"
                label="Description *"
            />

            <FloatingLabelInput
                v-model="formData.account_number"
                input-id="account-field"
                label="Account Number *"
            />

            <FloatingLabelInput
                v-model="formData.iban"
                input-id="iban-field"
                label="IBAN *"
            />

            <FloatingLabelInput
                v-model="formData.swift"
                input-id="swift-field"
                label="BIC / SWIFT Code *"
            />

            <FloatingLabelInput
                v-model="formData.currency"
                input-id="currency-field"
                label="Currency"
            />

            <div class="mt-4">
              <textarea
                  v-model="formData.additional_info"
                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none"
                  placeholder="Additional Information"
                  rows="4"
              ></textarea>
            </div>
          </div>

          <!-- Confirm Button -->
          <div class="flex justify-end pt-4">
            <button
                type="submit"
                class="bg-gray-800 hover:bg-gray-600 text-white font-semibold px-8 py-3 rounded-md transition-colors duration-200 tracking-wide"
            >
              CONFIRM
            </button>
          </div>
        </form>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import FloatingLabelInput from '@/components/ui/FloatingLabelInput.vue'
import { ref, defineProps, defineEmits } from 'vue'
import api from '@/services/api' // فرض: axios اینجا کانفیگ شده

defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'submitted'])

const formData = ref({
  name: '',
  description: '',
  account_number: '',
  iban: '',
  swift: '',
  currency: '',
  additional_info: '',
  type: 'european', // می‌تونی اینو از کاربر بگیری یا دیفالت بذاری
})

const closeModal = () => {
  emit('close')
}

const resetForm = () => {
  formData.value = {
    name: '',
    description: '',
    account_number: '',
    iban: '',
    swift: '',
    currency: '',
    additional_info: '',
    type: 'european',
  }
}

const handleSubmit = async () => {
  try {
    const token = localStorage.getItem('token')
    const res = await api.post('/beneficiaries', formData.value, {
      headers: { Authorization: `Bearer ${token}` },
    })

    emit('submitted', res.data) // ارسال به والد
    resetForm()
    closeModal()
  } catch (err) {
    console.error('Error creating beneficiary:', err.response?.data || err)

    // بک‌اند پیام خطا رو توی err.response.data.message یا errors میده
    const message =
        err.response?.data?.message ||
        err.response?.data?.errors?.iban?.[0] ||
        'Failed to create beneficiary.'

    alert(message)
  }
}

</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .bg-white,
.modal-leave-active .bg-white {
  transition: transform 0.3s ease;
}

.modal-enter-from .bg-white,
.modal-leave-to .bg-white {
  transform: scale(0.9);
}
</style>
